module.exports = __webpack_public_path__ + "dbbc5996f5c946ab718d1f6cfe5c6668.png";